import React from 'react';

import { useTranslation } from '@lyearn/i18n';
import { ArrowForward } from '@lyearn/icons';
import { LinkButton, Stack, Typography } from '@lyearn/ui';

interface SeeMoreProps {
  onClick: () => void;
}

const SeeMore: React.FC<SeeMoreProps> = ({ onClick }) => {
  const { t } = useTranslation();

  return (
    <Stack alignItems="center" className="w-full px-20 pt-12 pb-20">
      <LinkButton color={'internal'} onClick={onClick}>
        <Typography variant="heading-xxs">{t('Common:Actions.SeeMore')}</Typography>
        <ArrowForward className="!h-16 !w-16 ms-4 rtl:rotate-180" />
      </LinkButton>
    </Stack>
  );
};

export default SeeMore;
